import { render, staticRenderFns } from "./educationHistory.vue?vue&type=template&id=2ecbb7f3"
import script from "./educationHistory.vue?vue&type=script&lang=js"
export * from "./educationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecbb7f3')) {
      api.createRecord('2ecbb7f3', component.options)
    } else {
      api.reload('2ecbb7f3', component.options)
    }
    module.hot.accept("./educationHistory.vue?vue&type=template&id=2ecbb7f3", function () {
      api.rerender('2ecbb7f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationHistory.vue"
export default component.exports